<template>
    <component
        :is="tagName"
        v-bind="resolvedAttrs"
        :class="buttonClasses"
        @click="$emit('click', $event)"
    >
        <slot></slot>
    </component>
</template>

<script>
export default {
    name: "PillButton",
    props: {
        type: {
            type: String,
            default: "button",
        },
        size: {
            type: String,
            default: "sm",
        },
        to: {
            type: [String, Object],
            default: null,
        },
        useGlowAnimation: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        tagName() {
            return this.to ? "router-link" : "button";
        },
        resolvedAttrs() {
            if (this.to) {
                return {to: this.to};
            }
            return {type: this.type};
        },
        buttonClasses() {
            return [
                "btn",
                `btn-${this.size}`,
                "dashboard-pill-btn",
                {"dashboard-pill-btn--glow": this.useGlowAnimation},
            ];
        },
    },
};
</script>

<style scoped>
.dashboard-pill-btn {
    background-color: transparent;
    border: 4px solid var(--bs-success, #198754);
    border-radius: 999px;
    color: var(--bs-success, #198754) !important;
    padding: 0.5rem 1.25rem;
    font-size: 0.95rem;
    line-height: 1.2;
    text-transform: none !important;
    font-weight: 700;
}

.dashboard-pill-btn--glow {
    animation: dashboard-pill-btn-glow 2.8s ease-in-out infinite;
}

.dashboard-pill-btn:hover,
.dashboard-pill-btn:focus {
    color: var(--bs-success, #198754) !important;
    filter: brightness(0.92);
}

.dashboard-pill-btn--glow:hover,
.dashboard-pill-btn--glow:focus {
    animation-play-state: paused;
    box-shadow: 0 0 16px 4px rgba(25, 135, 84, 0.4);
}

@media (prefers-reduced-motion: reduce) {
    .dashboard-pill-btn--glow {
        animation: none;
    }

    .dashboard-pill-btn--glow:hover,
    .dashboard-pill-btn--glow:focus {
        box-shadow: none;
    }
}

@keyframes dashboard-pill-btn-glow {
    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(25, 135, 84, 0);
    }

    50% {
        box-shadow: 0 0 20px 6px rgba(25, 135, 84, 0.5);
    }
}
</style>
